import addStartupScript from './events/addStartupScript';
import MicroModal from 'micromodal';
import 'element-closest-polyfill';

function showMicroModal(modalId) {
  MicroModal.show(modalId, {
    onShow: micromodalOpen,
    onClose: micromodalClose,
    openClass: 'js-micromodal--open',
    awaitOpenAnimation: true,
  });
}

function micromodalOpen() {
  document.documentElement.classList.add('html--micromodal-open');
}

function micromodalClose(_modal, _element, event) {
  event.preventDefault();
  document.documentElement.classList.remove('html--micromodal-open');
}

function micromodalClickHandler(event){
  const trigger = event.target.closest('.js-micromodal-trigger');
  if (trigger) {
    showMicroModal(trigger.dataset.micromodalId);
  }
}

export function microModalTimeout() {
  // If micromodal contains the param "timer: X" the micromodal will open after X seconds
  // 0 means micromodal opens on page load
  const timer = document.querySelector('.micromodal--timer');
  if (timer) {
    const timerLength = parseInt(timer.dataset.timeout) * 1000;
    setTimeout(showMicroModal, timerLength, timer.id);
  }
}

export function setup() {
  document.addEventListener('click', micromodalClickHandler);
  microModalTimeout();
}

addStartupScript(setup);
